import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import type { RootState } from "../store";
import { getDefaultLandingPath } from "../types/user";

const HomeRedirect = () => {
  const { user, isAuthenticated, loading } = useSelector((state: RootState) => state.user);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Navigate to={getDefaultLandingPath(user)} replace />;
};

export default HomeRedirect;
